import { render, staticRenderFns } from "./controlmodel.vue?vue&type=template&id=2e125ecb&scoped=true"
import script from "./controlmodel.vue?vue&type=script&lang=js"
export * from "./controlmodel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e125ecb",
  null
  
)

export default component.exports